<template>
  <div class="slide-panel">
    <div class="language-container">
      <LanguageSelector/>
    </div>
    <div class="prestart-container">
      <div class="welcome">Loading...</div>
      <div class="flex-grow"></div>
      <div class="flex flex-col mb-12">
        <div class="flex justify-center">
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>

<style scoped lang="postcss">
.welcome {
  margin-top: 80px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: 18px;
}

.prestart-container {
  @apply flex flex-col h-full items-center;
  background: black;
  color: white;
  justify-content: space-around;
}

input[type="checkbox"] {
  display: none;
}

.slide-panel {
  @apply fixed top-0 right-0 h-full w-full bg-black z-50 flex flex-col;
  font-family: Montserrat, sans-serif;
  color: white;
}

.language-container {
  position: absolute;
  top: 8px;
  right: 10px;
}

/* for safari mobile */
@supports (-webkit-hyphens: none) {
  .fix-height-crossbrowser {
    @apply !pt-0 !mt-12;
  }
}

.fix-height-crossbrowser {
  @apply pt-12 mt-0;
}
</style>